import {
  PublicClientApplication,
  type Configuration,
} from "@azure/msal-browser";

export function createMsalInstance(authConfig: any) {
  const msalConfig: Configuration = {
    auth: {
      clientId: process.env.REACT_APP_MSAL_CLIENT_ID || "",
      authority: `https://login.microsoftonline.com/common/v2.0`,
      redirectUri: authConfig.redirectUri || window.location.origin,
      postLogoutRedirectUri: authConfig.redirectUri || window.location.origin,
    },
    cache: { cacheLocation: "sessionStorage" },
  };

  const msalInstance = new PublicClientApplication(msalConfig);

  const loginRequest = {
    scopes: [`api://${authConfig.clientId}/access_as_user`],
  };

  return { msalInstance, loginRequest };
}
